import React, { useEffect, useRef, useState } from "react"

import { useSelector } from "react-redux"
import { DEVICE_UPDATE_STATUS } from "../../util/constants"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import CreateUpdateModal from "./createUpdateModal"
import UpdateDropModal from "./updateDropModal"

export default function DeviceUpdatesTable() {
  const [processedUpdates, setProcessedUpdates] = useState([])
  const [modalData, setModalData] = useState({ open: false })
  const deviceUpdates = useSelector((state) => state.deviceUpdates.updates)
  const allReleases = useSelector((state) => state.deviceUpdates.allReleases)
  const deviceData = useSelector((state) => state.device.deviceData)
  const user = useSelector((state) => state.user)
  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder.addFilter(
      FILTER_TYPE.UPDATES.OVERALL_STATUS,
      true,
    )
      .addFilter(FILTER_TYPE.UPDATES.ID, true)
      .addFilter(FILTER_TYPE.UPDATES.ALG_RELEASE_ID, true)
      .addFilter(FILTER_TYPE.UPDATES.FIRMWARE_VERSION, true)
      .addFilter(FILTER_TYPE.UPDATES.CREATED_ON, true)
      .addFilter(FILTER_TYPE.UPDATES.CYCLE_TIME, false)
      .addFilter(FILTER_TYPE.UPDATES.TRIGGER_NUMBER, false)
      .addFilter(FILTER_TYPE.UPDATES.DEVICE_COUNT, true)
      .addFilter(FILTER_TYPE.UPDATES.DEVICE_IDS, false)
      .build()
  }
  const filterManager = filterManagerRef.current

  const handleClick = (_, row) => {
    const newModalData = {
      open: true,
      updateId: row.update_id,
      devices: row.devices,
      status: row.status,
    }
    setModalData(newModalData)
  }

  const handleClose = (shouldReload) => {
    setModalData({ open: false })
    if (shouldReload) {
      setProcessedUpdates([
        ...deviceUpdates.map((update, index) => {
          return {
            ...filterManager.generateDataMap(
              undefined,
              undefined,
              undefined,
              undefined,
              update,
              undefined,
            ),
            id: index,
            status: update.status,
            devices: update.deviceIds,
            no_click: update.status !== DEVICE_UPDATE_STATUS.PENDING,
          }
        }),
      ])
    }
  }

  useEffect(() => {
    if (deviceUpdates) {
      setProcessedUpdates([
        ...deviceUpdates.map((update, index) => {
          return {
            ...filterManager.generateDataMap(
              undefined,
              undefined,
              undefined,
              undefined,
              update,
              undefined,
            ),
            id: index,
            status: update.status,
            devices: update.deviceIds,
            no_click: update.status !== DEVICE_UPDATE_STATUS.PENDING,
          }
        }),
      ])
    }
  }, [deviceUpdates, filterManager.generateDataMap])

  return (
    <>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.UPDATES.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedUpdates}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
        AdditionalToolbar={
          <CreateUpdateModal
            allReleases={allReleases}
            user={user}
            allDeviceIds={deviceData.map((device) => device.device_id.toString())}
          />
        }
      />
      {modalData?.updateId && modalData.status === DEVICE_UPDATE_STATUS.PENDING && (
        <UpdateDropModal
          updateId={modalData.updateId}
          devices={modalData.devices}
          open={modalData.open}
          handleClose={handleClose}
        />
      )}
    </>
  )
}
